// extracted by mini-css-extract-plugin
export default {"google-button":"GoogleAuthButton_google-button__Y8oYA"};